import * as React from "react";
function SvgIcSwitch(props) {
  return <svg width="1em" height="1em" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect width={22} height={22} rx={11} fill="currentColor" /><path d="M5 9h12l-3-3M17 13H5l3 3" stroke="#fff" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>;
}
export default SvgIcSwitch;